interface GetAllCommunicationsParams {
	page?: number;
	limit?: number;
	sortBy?: string;
	sortOrder?: "asc" | "desc";
}

export const communicationsQueryKeys = {
	all: ["communications"] as const,
	lists: () => [...communicationsQueryKeys.all, "lists"] as const,
	list: (filters: string) =>
		[...communicationsQueryKeys.all, "list", filters] as const,
	allWithParams: (params?: GetAllCommunicationsParams) =>
		[...communicationsQueryKeys.all, "all", params] as const,
	unprocessed: (params?: GetAllCommunicationsParams) =>
		[...communicationsQueryKeys.all, "unprocessed", params] as const,
	details: () => [...communicationsQueryKeys.all, "details"] as const,
	detail: (id: string) =>
		[...communicationsQueryKeys.all, "details", id] as const,
};
